<template>
  <div class="score-q">
    <div class="score-q__meta">
      <span class="m600 sec-label">{{ copy.questionOf(index + 1, total) }}</span>
      <span class="m600 sec-label">{{ domain.id }} &middot; {{ domain.name }}</span>
    </div>
    <p class="o500 score-q__text" tabindex="-1" data-scorer-focus>{{ question.t }}</p>
    <p v-if="question.hint" class="m500 score-q__hint">{{ question.hint }}</p>
    <div class="score-q__answers">
      <sec-button
        v-for="opt in options"
        :key="opt.value"
        :variant="opt.variant"
        class="score-q__btn"
        @click="emit('answer', opt.value)"
      >
        {{ opt.label }}
      </sec-button>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import SecButton from '@/components/security/ui/SecButton.vue';
import { DOMAINS } from '@/content/security/domains';
import { ANSWER_OPTIONS, SCORER_COPY } from '@/content/security/score';

const props = defineProps({
  question: { type: Object, required: true }, // { d, t, good, hint }
  index: { type: Number, required: true },
  total: { type: Number, required: true },
});

const emit = defineEmits(['answer']);

const copy = SCORER_COPY;
const options = ANSWER_OPTIONS;
const domain = computed(() => DOMAINS.find((d) => d.id === props.question.d));
</script>

<style scoped>
.score-q {
  display: flex;
  flex-direction: column;
  gap: var(--sec-s3);
  flex: 1;
}

.score-q__meta {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: baseline;
  gap: var(--sec-s2);
}

.score-q__text {
  font-size: 1.15rem;
  line-height: 135%;
  color: var(--sec-ink);
  max-width: 34ch;
}

.score-q__hint {
  font-size: 0.88rem;
  color: var(--sec-ink-3);
}

.score-q__answers {
  display: flex;
  flex-wrap: wrap;
  gap: var(--sec-s2);
  margin-top: auto;
}

.score-q__btn {
  min-width: 104px;
}

@media only screen and (min-width: 700px) {
  .score-q__text {
    font-size: 1.45rem;
  }
}
</style>
